import { defineComponent as _defineComponent } from 'vue'
import i18n from '@/initI18n';

import ExternalAuthenticationLayout from '@/layout/components/ExternalAuthenticationLayout.vue';
import CnhImage from '@/shared/components/CnhImage.vue';
import { CNH_STATE_KEY, baseUrl } from '@/shared/constants';

import ModalWrapper from './ModalWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginCnh',
  props: {
  visible: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const $t = i18n.translate;

/* PROPS */


/* METHODS */
function login() {
  const state = Math.floor(100000 + Math.random() * 900000);
  localStorage.setItem(CNH_STATE_KEY, state.toString());
  const options = {
    client_id: 'n9PzW2YVx2ru9n8UCQ4LPq3PVJUYnqDk',
    response_type: 'code',
    redirect_uri: `${origin}${baseUrl}oauth/cnh`,
    scope: 'offline_access',
    connection: 'PROD-ADFS-CONN',
    state,
    audience: 'https://ag.api.cnhind.com',
  };
  window.open(
    `https://identity.cnhind.com/authorize?client_id=${options.client_id}&response_type=${options.response_type}&redirect_uri=${options.redirect_uri}&scope=${options.scope}&connection=${options.connection}&state=${options.state}&audience=${options.audience}`,
  );
}

return { __sfc: true,$t, login, ExternalAuthenticationLayout, CnhImage, ModalWrapper }
}

})